import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';

class PaginationNavigation extends Component {
  handlePageClick = data => {
    this.props.handlePageClick(data.selected + 1);
  };

  render() {
    if (this.props.paginationData.totalCount === 0) {
      return null;
    }
    return (
      <ReactPaginate
        previousLabel={<i className="fa fa-angle-left" />}
        nextLabel={<i className="fa fa-angle-right" />}
        breakLabel={<a>...</a>}
        pageCount={this.props.paginationData.pageCount}
        forcePage={this.props.paginationData.currentPage - 1}
        marginPagesDisplayed={1}
        pageRangeDisplayed={4}
        onPageChange={this.handlePageClick}
        containerClassName={'pagination m-t-0'}
        subContainerClassName={'pages pagination'}
        activeClassName={'active'}
      />
    );
  }
}

PaginationNavigation.propTypes = {
  paginationData: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired
  }).isRequired,
  handlePageClick: PropTypes.func.isRequired
};

export default PaginationNavigation;



// WEBPACK FOOTER //
// ./src/components/Common/Pagination/PaginationNavigation.js